import { Pipe, PipeTransform } from '@angular/core';
import { ProjektRettighed } from 'src/app/api/models';
@Pipe({
  name: 'filter',
})
export class FilterBrugerPipe implements PipeTransform {
  transform(projektRettigheder: ProjektRettighed[], filterBrugerId: string): ProjektRettighed[] {
    if (!projektRettigheder || !filterBrugerId) {
      return projektRettigheder;
    }
    return projektRettigheder.filter(rettighed => {
      return rettighed.brugerId === filterBrugerId;
    });
  }
}
